import { MedicaoQueryModel } from 'view/atendimentos/detail/components/modals/medicoes/model-medicoes'
import { MEDICOES_ANTROPOMETRIA_PAC } from 'view/atendimentos/detail/historico/model/model-historico'

export function isMedicaoPac(medicao: MedicaoQueryModel): boolean {
  return MEDICOES_ANTROPOMETRIA_PAC.some((medicaoPac) => medicao[medicaoPac])
}

export function isMedicaoAnterior(medicao: MedicaoQueryModel): boolean {
  return !!medicao?.medicaoAnterior
}

export function mustSkipMedicoesAnterioresImcQuery(
  prontuarioId: ID | undefined,
  canAccessMedicoesAnteriores: boolean
): boolean {
  return !prontuarioId || !canAccessMedicoesAnteriores
}
